export default __webpack_public_path__ + "static/media/Hallowed Ring of Divine Blessings.71edc2a5.jpg";